import { Box, Text } from '@rbilabs/universal-components';

import { ListCardGroupVariant } from './types';

export const NUM_COLUMNS = 3;
export const CONTENT_CONTAINER_PADDING_MOBILE = 10;

export const ListCardGroupContainer = Box.withConfig<{ $isFullContainer: boolean }>(
  ({ $isFullContainer }) => ({
    width: 'full',
    paddingX: { base: '$0', md: $isFullContainer ? '$0' : '$64' },
  })
);

export const ListHeader = Text.withConfig<{ listCardGroupVariant: ListCardGroupVariant }>(
  ({ listCardGroupVariant }) => ({
    accessible: true,
    focusable: true,
    variant: 'headerTwo',
    fontSize: { base: '16px', md: '18px' },
    marginY: '$2',
    paddingX: '$2',
    textAlign: listCardGroupVariant === ListCardGroupVariant.SINGLE ? 'center' : 'initial',
  })
);

export const RenderItemRowContainer = Box.withConfig<{
  listCardGroupVariant: ListCardGroupVariant;
}>(({ listCardGroupVariant }) => ({
  flexDirection: 'row',
  justifyContent: listCardGroupVariant === ListCardGroupVariant.SINGLE ? 'center' : 'initial',
}));
